import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SVG from "../../../Components/SVG";
import { isoToJalali } from "../../../helper/isoToJalali";
import { API_BASE_URL } from "../../../config/api";
export default function AccountInfo() {
  function addDays(isoString, days) {
    const date = new Date(isoString);
    date.setDate(date.getDate() + days);
    return date.toISOString(); // or return date
  }

  console.log(addDays("2025-12-04T14:16:41.277386+03:30", 5));
  const { accountId } = useParams();
  const [accountData, setAccountData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/accounts/${accountId}/data/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            window.location.href = "/signin";
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}/api/v0/challenges/admin/accounts/${accountId}/data/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  useEffect(() => {
    fetchAccountData();
  }, []);
  return (
    <div className="w-full h-fit flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden">
      <h2 className="flex gap-2.5 items-center">
        <SVG
          name="info"
          classname="size-5 stroke-zi-blue-dark dark:stroke-white"
        />
        <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          اطلاعات حساب
        </span>
      </h2>

      <div className="w-full h-fit text-nowrap overflow-auto flex divide-x divide-x-reverse divide-zi-border-light dark:divide-zi-border-dark [&>*:not(:last-child)]:pl-5 [&>*:not(:first-child)]:pr-5">
        <div className="w-full flex flex-col gap-5">
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              سرمایه اولیه:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData &&
                Number(
                  accountData.account.initial_balance,
                ).toLocaleString()}{" "}
              دلار
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              پلتفرم معامله:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              پلتفرم کوژیتو
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              نوع بازار:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              ارز دیجیتال
            </span>
          </div>
        </div>

        <div className="w-full flex flex-col gap-5">
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              نوع حساب:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData &&
                (accountData.challenge.challenge_type === "real"
                  ? "چالش"
                  : "تمرینی")}
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              نوع چالش:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData &&
                `${accountData.challenge.name} | ${accountData.challenge.category}`}
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              نوع فاز:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData &&
                (accountData.phase.phase_type === "phase1"
                  ? "فاز اول"
                  : accountData.phase.phase_type === "phase2"
                    ? "فاز دوم"
                    : "فاندد")}
            </span>
          </div>
        </div>

        <div className="w-full flex flex-col gap-5">
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              تاریخ شروع:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData && isoToJalali(accountData.account.created_at)}
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              تاریخ پایان:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {
                //if accountData.status === "live" then i should show accountData.created_at(which is in iso format) + accountData.phase.duration else show accountData.updated_at
                accountData &&
                  (accountData.account.status === "live"
                    ? isoToJalali(
                        addDays(
                          accountData.account.created_at,
                          accountData.phase.duration,
                        ),
                      )
                    : isoToJalali(accountData.account.updated_at))
              }
            </span>
          </div>
          <div className="flex gap-2">
            <span className="text-base font-normal text-zi-text-light dark:text-zi-text-dark">
              نام کاربر:
            </span>
            <span className="text-base font-medium text-zi-text-light dark:text-zi-text-dark">
              {accountData && accountData.user.fn && accountData.user.ln
                ? `${accountData.user.fn} ${accountData.user.ln}`
                : "-"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
